import { render, staticRenderFns } from "./TaskEditDetails.vue?vue&type=template&id=50ea5049"
import script from "./TaskEditDetails.vue?vue&type=script&lang=js"
export * from "./TaskEditDetails.vue?vue&type=script&lang=js"
import style0 from "./TaskEditDetails.vue?vue&type=style&index=0&id=50ea5049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports